import { Button, Form, SelectProps, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { format, subDays } from 'date-fns';
import React, { useEffect, useState } from 'react';
import DatePickerModal from '../../../../../components/DatePickerModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;

const pageSize = 20;
type OptionDefinition = SelectProps.Option;
export const MasterParametersHolidays = () => {
    const { menu } = useGlobalState();

    type OptionDefinition2 = {
        label: string;
        value: string;
    };



    //const storeAdmin = useStoreAdmin();


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);




    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [holidays, setHolidays] = useState<ItemHoliday[]>([]);
    const [holidayPicker, setHolidayPicker] = useState(false);




    type ItemHoliday = {
        idHoliday: number,
        fecha: string,
        date: string
    };

    useEffect(() => {
        handleGetHolidays()
    }, []);


    const handleAddHoliday = async (date: string) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/holidays/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idHoliday: 0,
                    date: date,
                    start: format(new Date(), "dd-MM-yyyy")
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                handleGetHolidays()
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleGetHolidays = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/holidays/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    orderBy: "date",
                    order: "asc",
                    start: format(subDays(new Date(), 1), "dd-MM-yyyy")
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setHolidays(data.holidays)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header variant='h2' actions={
                            <SpaceBetween direction='horizontal' size="xs">
                                <Button variant="primary" onClick={() => setHolidayPicker(true)}>Agregar</Button>
                                <Favorites />
                            </SpaceBetween>}>
                            Maestro de Parametros</Header>

                        <Form actions={
                            <>

                                <DatePickerModal visible={holidayPicker} onDismiss={() => setHolidayPicker(false)} onConfirm={(date) => {
                                    handleAddHoliday(date);
                                    setHolidayPicker(false)
                                }} />
                            </>

                        }>

                            <Table
                                variant="embedded"
                                columnDefinitions={[
                                    {
                                        id: "idHoliday",
                                        header: "ID",
                                        width: 100,
                                        cell: item => item.idHoliday,
                                    },
                                    {
                                        id: "holiday",
                                        header: "Fecha",
                                        width: 120,
                                        cell: item => item.date,
                                    },
                                ]}
                                items={holidays ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin feriados asociados</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                            />

                        </Form>
                    </SpaceBetween>

                </>
            }
        />
    );
};